import React, { useState } from 'react';
import {
  Container,
  CardContainer,
  PieceTypesCard,
  PieceTypesCardLoading
} from './releaseToggleStyles';
import {
  IPieceType,
  IPieceTypesState,
  ISteelTypesState
} from '../../../../../store/ducks/fabrication/types';
import Skeleton from 'react-loading-skeleton';
import {
  DEFAULT_EXTRA_ITEM,
  IFabricationOrderExtraItem
} from '../../../../../store/ducks/fabrication-purchase-order/types';
import { getPieceImg } from '../../../../../utils/fabricationPieceTypesImage';
import PieceTypesModal from './PieceTypesModal';

interface IPieceTypesProps {
  onAddItem(extraItem: IFabricationOrderExtraItem): void;
  pieceTypesState?: IPieceTypesState;
  steelTypesState?: ISteelTypesState;
}

const PieceTypes: React.FC<IPieceTypesProps> = ({
  onAddItem,
  pieceTypesState,
  steelTypesState
}) => {
  const [extraItem, setExtraItem] =
    useState<IFabricationOrderExtraItem>(DEFAULT_EXTRA_ITEM);

  const [selectedPieceType, setSelectedPieceType] = useState<IPieceType>();
  const [canShowModal, setCanShowModal] = useState(false);

  const onCloseModal = () => {
    setExtraItem(DEFAULT_EXTRA_ITEM);
    setCanShowModal(false);
    setTimeout(() => {
      setSelectedPieceType(undefined);
    }, 200);
  };

  const onAddItemClick = () => {
    onAddItem({ ...extraItem });
    onCloseModal();
  };

  return (
    <Container>
      {pieceTypesState &&
        !pieceTypesState.loading &&
        !pieceTypesState.error &&
        pieceTypesState.pieceTypes.map((pieceType, idx) => (
          <CardContainer key={idx}>
            <PieceTypesCard
              onClick={() => {
                setCanShowModal(true);
                setSelectedPieceType(pieceType);
                setExtraItem({
                  ...extraItem,
                  pieceTypeId: pieceType.id
                });
              }}
              src={getPieceImg(pieceType.description, 'svg')}
            />
            <span className="description">{pieceType.description}</span>
          </CardContainer>
        ))}

      {(!pieceTypesState || pieceTypesState.loading || pieceTypesState.error) &&
        [...Array(10)].map((_, idx) => (
          <CardContainer key={idx}>
            <PieceTypesCardLoading>
              <Skeleton height={'100%'} />
            </PieceTypesCardLoading>
            <span className="description">
              <Skeleton />
            </span>
          </CardContainer>
        ))}

      {selectedPieceType && (
        <PieceTypesModal
          extraItem={extraItem}
          setExtraItem={setExtraItem}
          selectedPieceType={selectedPieceType}
          selectedPieceTypeImage={getPieceImg(
            selectedPieceType.description,
            'svg'
          )}
          steelTypesState={steelTypesState}
          onCloseModal={onCloseModal}
          onAddItemClick={onAddItemClick}
          canShowModal={canShowModal}
        />
      )}
    </Container>
  );
};

export default PieceTypes;
